import { defineRouteMeta } from '@/router/helpers/defineRouteMeta';

const ReportPreview = () => import(/* webpackChunkName: "report" */ '@/bundles/Reports/views/ReportPreview.vue');

export default [
  {
    path: 'report/:id',
    name: 'ReportPreview',
    component: ReportPreview,
    props: true,
    meta: defineRouteMeta({
      appShell: true,
      title: 'Report',
      topBarTitle: 'Report Preview',
    }),
  },
];
